import { useQuery } from "@apollo/client/react";
import { graphql, type ResultOf, type VariablesOf } from "@tucan/graphql";
import { PROFILE_FRAGMENT } from "./profile.fragment";

export const PROFILE_QUERY = graphql(
  `
    query getProfile {
      user: getProfile {
        ...Profile
      }
    }
  `,
  [PROFILE_FRAGMENT],
);

export type Data = ResultOf<typeof PROFILE_QUERY>;
type Variables = VariablesOf<typeof PROFILE_QUERY>;

export const useProfileQuery = (
  options?: useQuery.Options<Data, Variables>,
): useQuery.Result<Data, Variables> =>
  useQuery<Data, Variables>(PROFILE_QUERY, options);
